import { render, staticRenderFns } from "./JobViewList.vue?vue&type=template&id=8dd29b54&scoped=true&"
import script from "./JobViewList.vue?vue&type=script&lang=js&"
export * from "./JobViewList.vue?vue&type=script&lang=js&"
import style0 from "./JobViewList.vue?vue&type=style&index=0&id=8dd29b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd29b54",
  null
  
)

export default component.exports